export const SERVICE_CENTER_APP_NAME = 'servicecenter';

export const statusColors = {
  delivered: 'positive6',
  failed: 'negative6',
  opened: 'positive6',
  sent: 'warning6',
  created: 'warning6'
};
